<template>
  <div class="col-12">
    <h3 class="fw-bold">{{ $t('cdb.subscriptions.tab_subscription_extension.title') }}</h3>
    <p v-html="$t('cdb.subscriptions.tab_subscription_extension.description')"></p>

    <form @submit.prevent="submitForm">
      <div class="my-5">
        <div class="d-flex justify-content-center align-items-center">
          <span>1 {{ $t('cdb.subscriptions.tab_subscription_extension.month') }}</span>
          <input
            type="range"
            min="1"
            max="6"
            v-model="months"
            step="1"
            class="form-range p-0 w-50 m-3"
            style="accent-color: black;"
          />
          <span>6 {{ $t('cdb.subscriptions.tab_subscription_extension.months') }}</span>
        </div>
        <div class="text-center mt-2">
          <span>{{ months }} {{ $t('cdb.subscriptions.tab_subscription_extension.months') }}</span>
        </div>
      </div>

      <h3 class="text-center">
        {{ $t('cdb.subscriptions.tab_subscription_extension.new_end_date') }} <span>{{ newEndDate }}</span>
      </h3>
      <p v-html="$t('cdb.subscriptions.tab_subscription_extension.info')"></p>

      <div class="form-check ms-4">
        <input
          type="checkbox"
          v-model="agbAccepted"
          id="agbCheckbox"
          class="form-check-input"
        />
        <label
          for="agbCheckbox"
          v-html="$t('cdb.subscriptions.tab_subscription_extension.agb_text')"
          class="form-check-label"
        ></label>
      </div>

      <div v-if="subscriptionData.extension_request.extension_request_status !== null && subscriptionData.extension_request.extension_request_status !== 'DECLINED'">
        <p class="text-danger">{{ $t('cdb.subscriptions.tab_subscription_extension.error_message') }}</p>
      </div>

      <div class="d-flex justify-content-center mt-5">
        <button
          class="btn btn-secondary"
          :disabled="!agbAccepted || isClicked || (subscriptionData.extension_request.extension_request_status !== null && subscriptionData.extension_request.extension_request_status !== 'DECLINED')"
        >
          {{ $t('cdb.subscriptions.tab_subscription_extension.button_text') }}
        </button>
      </div>
      <div>
        <p v-if="!isLoading && success" class="text-success">{{ $t('cdb.subscriptions.tab_subscription_extension.success_text') }}</p>
        <p v-else-if="!isLoading && !success" class="text-danger">{{ $t('cdb.subscriptions.tab_subscription_extension.error_text') }}</p>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'CdbTabSubscriptionExtension',
  props: {
    subscriptionData: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      months: 3,
      agbAccepted: false,
      success: false,
      isLoading: true,
      isClicked: false
    }
  },
  computed: {
    newEndDate() {
      const extendedDate = new Date(this.subscriptionData.timestamps.ends_at * 1000);
      extendedDate.setMonth(extendedDate.getMonth() + parseInt(this.months));
      return extendedDate.toLocaleDateString('de-DE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    }
  },
  methods: {
    async submitForm() {
      if (!this.agbAccepted) {
        alert(this.$t('cdb.subscriptions.tab_subscription_extension.agb_not_accepted'));
        return
      }
      if (!this.isClicked) {
        this.isClicked = true
        this.$axios.post('api/v1/dashboard/send/subscription_extension_request', {
          subscription: this.subscriptionData.uuid,
          months: this.months
        }).then(response => {
          this.success = true
          this.subscriptionData.extension_request.extension_request_status = 'REQUESTED';
          this.isLoading = false
        }).catch(error => {
          alert(this.$t('cdb.subscriptions.tab_subscription_extension.error_text'), error);
        });
      }
    }
  }
}
</script>
